<template>
  <el-dialog v-bind="$attrs" :visible.sync="dialogVisible" :before-close="handleClose" :close-on-press-escape="true" custom-class="elsa-modal" :center="center" top="50px" v-on:closed="closed">
    <api-errors :errors="errors" />
    <template v-slot:title>
      <slot name="title"> </slot>
    </template>
    <slot name="header"> </slot>

    <slot name="body"> </slot>

    <template v-slot:footer class="dialog-footer">
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
import ApiErrors from '@/components/common/ApiErrors'
export default {
  components: {
    ApiErrors
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    errors: {
      type: [Object, String, Array],
      default: () => []
    },
    center: {
      type:Boolean,
      default:false
    }
  },
  methods: {
    handleClose() {
      return this.$emit('closed')
    },
    closed() {}
  }
}
</script>

<style lang="scss" scoped>
</style>
